
export function timer(timerName) {
    const start = Date.now()
    return () => {
        const end = Date.now()
        console.log(`${timerName}:`, end - start)
    }
}
